import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import SeoMeta from '@/components/base/SeoMeta';
import JsonLd from '@/components/base/JsonLd';
import Hero from '@/pages/home/components/Hero';
import TickerBar from '@/pages/home/components/TickerBar';
import StatsBar from '@/pages/home/components/StatsBar';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestSection from '@/pages/home/components/LatestSection';
import ProcessSection from '@/pages/home/components/ProcessSection';
import FaqTeaser from '@/pages/home/components/FaqTeaser';

export default function Home() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const basePath = (__BASE_PATH__ || '/').replace(/\/$/, '');

  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '真相回旋镖',
      url: `${origin}${basePath}/`,
      description: '聚焦爆料反转、辟谣澄清与真相后续的观察站，帮你看清黑料背后的真实走向。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${origin}${basePath}/archive?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '真相回旋镖',
      url: `${origin}${basePath}/`,
      email: 'hello@truth-boomerang.example',
      description: '以时间线方式整理网络爆料反转与辟谣澄清的内容站点。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '最新反转与澄清案例',
      itemListElement: articles.slice(0, 6).map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `${origin}${basePath}/article/${item.id}`,
        name: item.title,
      })),
    },
  ];

  return (
    <>
      <SeoMeta
        title="真相回旋镖｜爆料反转、辟谣澄清与真相后续观察站"
        description="真相回旋镖聚焦网络爆料的反转与辟谣，整理最新黑料澄清、真相后续与打脸现场，标注时间线与核实状态，帮你看清黑料背后的真实走向。"
        keywords="爆料反转,辟谣澄清,黑料真相,黑料后续,舆情观察"
        path="/"
      />
      <JsonLd data={structuredData} />

      <Hero />
      <TickerBar />
      <StatsBar />
      <CategoryGrid />
      <LatestSection />
      <ProcessSection />
      <FaqTeaser />

      <section className="border-t border-background-300 bg-background-100">
        <div className="reveal mx-auto w-full px-4 py-14 md:px-6 md:py-16">
          <div className="flex flex-col items-start justify-between gap-6 rounded-lg border border-background-300 bg-background-50 p-6 md:flex-row md:items-center md:p-10">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950">
                下一次刷到爆料，先来核对一遍
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
                把完整案例档案存进收藏夹。遇到情绪浓度很高的信息时，先看看它有没有出现反转，再决定要不要转发。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <Link
                to="/archive"
                className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium font-label text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                <i className="ri-folder-open-line" aria-hidden="true" />
                打开反转档案
              </Link>
              <Link
                to="/about#contact"
                className="flex items-center justify-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-medium font-label text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-mail-send-line" aria-hidden="true" />
                提交核实线索
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}